define('app/sdc/wizard/sdc-wizard',["$q", "$parse"], function ($q, $parse) {
	return {
		require: {
			"closableSection": "^?sdc-closable-section",
			"sdcWizardSubmit": "?sdc-wizard-submit"
		},
		template: null,
		restrict: "AE",
		scope: false,
		controller: {
			defaults: {
				"steps": [],
				"isClosable": true,
				"wizardAs": "$wizard"
			},
			bind: {
				"isClosable": "=?",
				"currentStepIndex": "=?currentIndex",
				"wizardAs": "@?sdcWizard",
			},
			prototype: {
				transitioning: false,
				currentStepIndex: 0,
				registerStep: function registerStep(stepController) {
					this.steps.push(stepController);
					return this.unregisterStep.bind(this, stepController);
				},
				unregisterStep: function unregisterStep(stepController) {
					var index = this.steps.indexOf(stepController);
					if (index >= 0) {
						var removed = this.steps.splice(index, 1)[0];
						return this.unregisterStep(stepController) || removed;
					}
					else {
						return null;
					}
				},
				close: function close() {
					if (this.isClosable && this.closableSection) {
						this.closableSection.close();
						return true;
					}
					else {
						return false;
					}
				},
				next: function next() {
					var vm = this,
						currentStep = vm.steps[vm.currentStepIndex];
					if (angular.isFunction(currentStep.canCompleteStep) ? currentStep.canCompleteStep() : currentStep.canCompleteStep) {
						var stepResult = vm.loading = $q.if(currentStep.completeStep()).then(function $then() {
							if (stepResult !== vm.loading) {
								return;
							}
							if (++vm.currentStepIndex >= vm.steps.length) {
								--vm.currentStepIndex;
								if (vm.sdcWizardSubmit) {
									var submitResult = vm.loading = $q.if(vm.sdcWizardSubmit.submit()).then(function () {
										if (!vm.close()) {
											vm.currentStepIndex = 0;
										}
									});
								}
								if (!vm.close()) {
									vm.currentStepIndex = 0;
								}
							}
						});
					}
				},
				previous: function previous() {
					this.loading = null;
					if (--this.currentStepIndex < 0) {
						this.currentStepIndex = 0;
						return this.close();
					}
					else {
						return true;
					}
				}
			},
			constructor: ["$self", "$scope", "$watch", function (vm, $scope, $watch) {
				$watch = $watch.context({ vm: vm });
				var destroyPrevious = angular.noop;
				var assignWizard = (function (wizardAs) {
					function setPublicWizard(assign, value) {
						vm.public = value;
						return assign(value);
					}
					function assignWizard(wizard) {
						wizardAs.assign($scope, angular.map(wizard, function (value) {
							if (value && angular.isFunction(value)) {
								return value.bind(vm);
							}
							else {
								return value;
							}
						}));
					}
					if (wizardAs && wizardAs.assign) {
						return setPublicWizard.bind(null, assignWizard);
					}
					else {
						return setPublicWizard.bind(null, angular.noop);
					}
				}($parse(vm.wizardAs)));
				$watch.group({
					"next": "(vm.steps[vm.currentStepIndex].canCompleteStep() && vm.steps[vm.currentStepIndex].completeStep && ! vm.transitioning) ? vm.next : undefined",
					"previous": "((vm.currentStepIndex > 0 || vm.isClosable && vm.closableSection) && !vm.transitioning) ? vm.previous : undefined",
					"nextText": "vm.steps[vm.currentStepIndex].nextText || ((vm.currentStepIndex + 1 < vm.steps.length) ? 'Next' : 'Complete')",
					"previousText": "vm.steps[vm.currentStepIndex].previousText || (vm.currentStepIndex > 0 ? 'Previous' : 'Close')",
					"currentStep": "vm.steps[vm.currentStepIndex]"
				}, assignWizard);
				$watch("vm.steps[vm.currentStepIndex]", function (currentStep) {
					destroyPrevious();
					if (currentStep) {
						var promise = currentStep.transclude();
						destroyPrevious = promise.destroy;
						var thisTransitioning = vm.transitioning = promise.then(function () {
							if (vm.transitioning === thisTransitioning) {
								vm.transitioning = false;
							}
						});
					}
					else {
						destroyPrevious = angular.noop;
						vm.transitioning = null;
					}
				});
				angular.extend(vm, {
					next: vm.next.bind(vm),
					previous: vm.previous.bind(vm)
				});
			}]
		}
	};
});
